import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { ENTER } from '@angular/cdk/keycodes';

@Component({
    selector: 'app-lob-add-remove-architect',
    templateUrl: './lob-add-remove-architect.component.html',
    styleUrls: ['./lob-add-remove-architect.component.css'],
    standalone: false
})
export class LobAddRemoveArchitectComponent implements OnInit {
  @Input() lobdropdwnDataSource;
  @Input() selectedInitiative: any;
  @Input() clearFormFields: boolean = false;
  @Output() addRemoveSuccessEvent: EventEmitter<any> = new EventEmitter();
  @Input() dataSource: any;
  reqPayload: any;
  private subject: Subject<string> = new Subject();
  inputElement: any;
  users: any[];
  selectedUsers: any = {};
  setlobSublobToAll: boolean;
  seglobsubLob: any;
  role: any;
  clearAllSelection: boolean = false;
  showLoader: boolean = false;
  selectValues = [];
  disableMultiSelect: boolean = false;
  disableItems: any;
  separatorKeysCodes: number[] = [ENTER];
  architectAction: any = 'add';
  typeOfArchitect: any = '';
  cioMappingList: any = [];
  roleList = ['Chief Architect', 'Architect Delegate'];
  CAList: any;
  ADList: any;
  msidsArr: any;
  openAllPanel: boolean = false;
  hierarchyDropdownConfig = {
    parentfield: ['SegID', 'MasterSegment'],
    firstchildfield: ['lob_id', 'lob'],
    secondchildfield: ['SubLobID', 'sub_lob', 'sublob'],
    firstchildkey: 'lob',
    secondchildkey: 'subLob',
  };
  actualcioMappingList: any;
  ExCAList: any[];
  existingADList: any[];

  constructor(private maintenanceService: MaintenanceService, private capabilityService: CommonModelService,
    private toastr: ToastrService) { }

  submit() {
    if(this.selectedUsers.MSId) {
      this.selectedUsers['msid'] = this.selectedUsers.MSId;
      delete this.selectedUsers.MSId;
    }
    const reqBody = {
      action: this.architectAction,
      type_of_architect: this.typeOfArchitect,
      msid: this.selectedUsers,
      dataArr: this.seglobsubLob
    };
    this.showLoader = true;
    this.maintenanceService.addRemoveUsers(reqBody).subscribe(res => {
      if (res) {
        this.showLoader = false;
        this.toastr.success(res, '', { positionClass: 'toast-top-center', timeOut: 2000, })
        this.addRemoveSuccessEvent.emit(reqBody);
        this.clearFields();
      }
    }, (error) => {
      console.error(error);
      this.showLoader = false;
      this.toastr.error("Something went wrong, Please try again later.", '', { positionClass: 'toast-top-center', timeOut: 1000, })
    });
  }

  architectActionChange(event) {
    this.architectAction = event.value;
    this.clearSelectedUserandLob();

  }
  clearSelectedUserandLob() {
    this.openAllPanel = false;
    this.selectedUsers = {};
    this.selectValues = [];
    this.cioMappingList = (this.architectAction == 'remove' && this.selectedUsers?.displayName) ? this.filterSUBList() : JSON.parse(JSON.stringify(this.actualcioMappingList));

  }

  filterSUBList() {
    const msidsArray = [];
    this.dataSource.forEach(lob => {
      const tempobj = {
        "master_segment": lob.MasterSegment,
        "lob": lob.CIOLOB,
        "lob_id": lob.LobID,
        "subLob": []
      }
      lob.sublob.forEach(element => {
        const architectTyp = (this.typeOfArchitect == 'Chief Architect') ? 'ChiefArchitectLabel' : 'ArchitectDelegateLabel';
        if (element[architectTyp].includes(this.selectedUsers.displayName)) {
          tempobj.subLob.push({ 'sub_lob': element.SubLineofBusiness, 'SubLobID': element.SubLobID });
        }
      });
      tempobj.subLob.length ? msidsArray.push(tempobj) : false;
    });
    this.openAllPanel = true;
    return this.formatList(msidsArray);
  }

  getLobdata() {
    this.maintenanceService.getLOBList().subscribe(
      (response: any) => {
        if (response && response.length) {
          this.cioMappingList = this.formatList(response);
          this.actualcioMappingList = JSON.parse(JSON.stringify(this.cioMappingList))
        }
      },
      (err) => {
        this.showErrMsg(err);
      }
    );
  }


  formatList(list: any) {
    const filterValues = [...new Set(list.map(ele => ele.master_segment))];
    const finalList: any = [];
    filterValues.forEach((ele: any) => {
      const filteredList = list.filter(item => ele == item.master_segment);
      const tempobj = {
        MasterSegment: filteredList[0]?.master_segment,
        lob: filteredList
      };
      finalList.push(tempobj);
    });

    return finalList;
  }
  showErrMsg(err: any) {
    this.showLoader = false;
    if (err && err.message) {
      this.toastr.error(err.message, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  ngOnInit(): void {
    this.selectedUsers = {};
    this.getLobdata();
    this.filterExistingCAUsersList();
    console.log(this.dataSource)
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  ngOnChanges() {
    if (this.clearFormFields) {
      this.clearFields();
    }
  }

  private addUniqueUser(userList: any[], user: any): void {
    const existingUser = userList.find(item => item.msid === user.msid);
    if (!existingUser) {
      userList.push(user);
    }
  }

  private processChiefArchitects(sublob: any, caList: any[]): void {
    sublob.ChiefArchitect.forEach(ca => {
      this.addUniqueUser(caList, ca);
    });
  }

  private processArchitectDelegates(sublob: any, adList: any[]): void {
    sublob.ArchitectDelegate.forEach(ad => {
      this.addUniqueUser(adList, ad);
    });
  }

  private processSublobs(element: any, caList: any[], adList: any[]): void {
    element.sublob.forEach(sublob => {
      this.processChiefArchitects(sublob, caList);
      this.processArchitectDelegates(sublob, adList);
    });
  }

  filterExistingCAUsersList() {
    const CA = [];
    const AD = [];
    
    this.dataSource.forEach(element => {
      this.processSublobs(element, CA, AD);
    });
    
    this.ExCAList = CA;
    this.existingADList = AD;
    console.log(this.ExCAList, this.existingADList);
  }

  keyUpSearch(name) {
    const p: any = {}
    p['search'] = name.target.value;
    this.inputElement = name;
    if (this.architectAction == 'remove') {
      this.users = [];
      if (this.typeOfArchitect == 'Chief Architect') {
        this.users = this.ExCAList.filter(
          obj =>
            obj.msid.toLowerCase().includes(name.target.value.toLowerCase()) ||
            obj.displayName.toLowerCase().includes(name.target.value.toLowerCase()) ||
            obj.mail.toLowerCase().includes(name.target.value.toLowerCase())
        );
      } else if (this.typeOfArchitect == 'Architect Delegate') {
        this.users = this.existingADList.filter(
          obj =>
            obj.msid.toLowerCase().includes(name.target.value.toLowerCase()) ||
            obj.displayName.toLowerCase().includes(name.target.value.toLowerCase()) ||
            obj.mail.toLowerCase().includes(name.target.value.toLowerCase())
        );
      } else {
        this.subject.next(p);
      }

    }
    else if (this.architectAction != 'remove' && name.target.value) {
      this.subject.next(p);
    }
    else {
      this.users = [];
    }
  }

  selected(event) {
    this.disableItems = [];
    if (event.option.value.givenName !== '') {
      this.selectedUsers = event.option.value;
      if (this.inputElement) {
        this.inputElement.target.value = '';
        this.users = []
      }
      this.cioMappingList = (this.architectAction == 'remove' && this.selectedUsers?.displayName) ? this.filterSUBList() : JSON.parse(JSON.stringify(this.actualcioMappingList));
      this.checkDisability();



    }
  }
  getCAADLOBList(SubLobID) {
    let msidsArray = [];
    this.dataSource.forEach(lob => {
      const element = lob.sublob.filter(x => x.SubLobID == SubLobID);
      if (element.length) {
        if (this.typeOfArchitect == "Chief Architect") {
          msidsArray = element[0].ChiefArchitect.map(item => item.msid);
        } else {
          msidsArray = element[0].ArchitectDelegate.map(item => item.msid);
        }
        return msidsArray;
      }

    });
    return msidsArray;
  }

  checkDisability() {
    if (this.architectAction != 'remove') {
      this.openAllPanel = false;
      this.msidsArr = [];
      this.cioMappingList.forEach(segment => {
        segment.lob.forEach(eachlob => {
          eachlob.subLob.forEach(element => {
            this.msidsArr = this.getCAADLOBList(element.SubLobID);
            element['disable'] = this.selectedUsers?.MSId && this.msidsArr.includes(this.selectedUsers.MSId) && this.architectAction == "add" ? true : false;
          });
        })
      });
    }
  }
  architectTypeChange() {
    this.clearSelectedUserandLob();
  }

  getAllSubLOB() {
    const allSUBLOB = [];
    this.cioMappingList.forEach(segment => {
      segment.lob.forEach(eachlob => {
        eachlob.sublob.forEach(item => {
          allSUBLOB.push(item.SubLobID)
        })
      })
    });
    return allSUBLOB;
  }

  remove() {
    this.clearSelectedUserandLob();
  }
  checkexist(user) {
    if (this.disableMultiSelect) {
      const userhasaccessalready = this.dataSource.filter(x => x.MSId == user.MSId && x.Role == this.role);
      return userhasaccessalready.length > 0 ? true : false;
    }

  }

  handleSearch(searchObj) {
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
        this.users = [];
        dataStream.forEach(element => {
          this.users.push({
            givenName: element.givenName,
            sn: element.sn,
            mail: element.mail,
            displayName: element.displayName,
            employeeID: element.employeeID,
            MSId: element.cn,
            middleName: element.middleName,
          });
        });
      }, (error) => {
        console.error(error);
      });
    } else {
      column.options = [];
    }
  }
  selectedHierarchy(data) {
    this.seglobsubLob = data;
  }
  disableSubmit() {
    return (this.seglobsubLob && this.seglobsubLob.length > 0 && (this.selectedUsers && this.selectedUsers.givenName) ? false : true);
  }
  clearFields() {
    this.seglobsubLob = [];
    this.selectedUsers = {};
    this.clearFormFields = false;
    this.selectValues = [];
    this.disableMultiSelect = false;
  }

}
